<template>
  <div class="intebl">
    <div class="intebl-background">
      <div class="appHelmetysen">积分账单<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="intebl-persal" @scroll="BaCoScrollqb($event)">
        <div class="intebl-toga">
          <p class="intebl-toga-text">总积分</p>
          <p class="intebl-toga-number">{{intagr}}</p>
        </div>
        <div class="intebl-grom">积分信息</div>
        <div class="intebl-cont" v-for="erintgda in intgda" :key="erintgda.ID">
          <p class="intebl-cont-text">
            <span v-if="erintgda.TYPE == '0'">消费赠送</span>
            <span v-else-if="erintgda.TYPE == '1'">绑定转入</span>
            <span v-else-if="erintgda.TYPE == '2'">系统清空</span>
            <span v-else-if="erintgda.TYPE == '3'">会员消费</span>
            <span v-else-if="erintgda.TYPE == '4'">消费退款</span>
            <span v-else-if="erintgda.TYPE == '5'">签到赠送</span>
            <span :class="erintgda.TYPE_FLAG == '+' ? 'intebl-cont-text-inse' : 'intebl-cont-text-ruce'">{{erintgda.TYPE_FLAG}}{{erintgda.INGEGRAL}}</span>
          </p>
          <p class="intebl-cont-tiem">
            <span class="intebl-cont-tiembk">{{erintgda.CREATE_DATE}}</span>
            <span class="intebl-cont-tiemyc">{{erintgda.TRANSACTION_NAME}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      loginID: '',
      intgda: '',
      inodagesng: 1,
      inprctes: '',
      intagr: ''
    }
  },
  created(){
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收积分商城首页传过来的总积分
    this.intagr = this.$route.query.potagr;
    // 积分账单
    this.$axios.post('app/mallScoreIntegralBill',this.$qs.stringify({
      MEMBER_ID: this.loginID,
      showCount: '18',
      currentPage: this.inodagesng
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.intgda = res.data.varList;
      this.inprctes = res.data.page.totalPage;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
     
  },
  methods:{
    // 滚动条触底的时候触发
    BaCoScrollqb(e) {
      // 滚动条卷起的高度
      let scrollTop = e.target.scrollTop;
      let scrollHeight = e.target.scrollHeight;
      let offsetHeight = Math.ceil(e.target.getBoundingClientRect().height);
      let currentHeight = scrollTop + offsetHeight;
      if(currentHeight - scrollHeight > 0 && this.inodagesng < this.inprctes){
        this.inodagesng = this.inodagesng + 1;
        // 滚动条触底的时候渲染新的数据
        this.$axios.post('app/mallScoreIntegralBill',this.$qs.stringify({
          // MEMBER_ID: this.loginID,
          showCount: '18',
          currentPage: this.inodagesng
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          this.intgda = [...this.intgda,...res.data.varList];
        })
        .catch(() => {
          // console.log('未登录获取数据失败');
        });
      }
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/intebl.css";
</style>